import { MouseEvent } from 'react'
import { noop } from 'lodash'
import Link from '@components/Link'
import { CallbackLinkActionProps } from '@features/resource_actions/types'

// A link action with an interceptable onClick handler.
// Handy for when you want to handle the link click elsewhere
const CallbackLinkAction = (props: CallbackLinkActionProps) => {
  const { callback = noop, onDone = noop, label = 'Edit details' } = props

  const handleClick = (e: MouseEvent) => {
    e.preventDefault()
    onDone()
    callback()
  }

  return (
    <Link href="#" onClick={handleClick}>
      {label}
    </Link>
  )
}

export default CallbackLinkAction
